import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import Select from "react-select"
import { mapApiArrayData } from "helpers/helpers"
import { assignRoles } from "store/roles/actions"
const PermissionDetailsModal = props => {
  const { isOpen, toggle, roleList, setRoleList, detailsModal } = props

  const Permissions = useSelector(state => state.permissions.Index ?? [])
  const [list, setList] = useState([])
  const dispatch = useDispatch()

  const handleSave = () => {
    let permissionIds = list.map(item => item.value)
    dispatch(
      assignRoles({ permissions: permissionIds }, roleList.roleId, toggle)
    )
  }
  const handleChange = fullList => {
    setList(fullList)
  }
  useEffect(() => {
    let fullList = mapApiArrayData(roleList?.permissions ?? [])
    setList(fullList)
  }, [detailsModal])

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>Assigned Permissions</ModalHeader>
        <ModalBody>
          <p className="mb-2">
            <span className="" style={{ fontWeight: "bold" }}>
              Role Name: &nbsp;
            </span>
            <span className="">{roleList.name}</span>
          </p>
          <div className="mb-3">
            <label className="control-label" style={{ fontWeight: "bold" }}>
              Assign New Role:
            </label>
            <Select
              value={list.map(item => {
                return {
                  label: item.label,
                  value: item.value,
                }
              })}
              maxMenuHeight={150}
              isMulti={true}
              onChange={item => {
                handleChange(item)
              }}
              options={mapApiArrayData(Permissions)}
              classNamePrefix="select2-selection"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Close
          </Button>
          <Button type="button" color="success" onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

export default PermissionDetailsModal
